<style lang="scss">
.tooltip-boxss{
    border: none !important;
    box-shadow: 2px 5px 10px rgba($color: #ededed, $alpha: 0.6);

    .popper__arrow{
        // 下边框线
        &::after{
            border-bottom-color: #fff!important;
        }
        border-top-color: #fff !important;
        
    }
}

</style>
<template>
    <div class="page-box">
        <div class="banner">
            <div class="banner-box df">
                <div class="img-box fn">
                    <img :src="info.teb_thumb" alt="">
                </div>
                <div class="text-box f1 over-h">
                    <div class="title fs-30 fw-b">{{ info.teb_title }}</div>
                    <div class="desc fs-14 lh-26">
                        {{ info.teb_desc }}
                    </div>
                    <el-button type="primary" class="download-btn" @click="download($event, info)">{{ $t('本期下载') }}</el-button>

                    <!-- 列表 -->
                    <div class="list-box df fww over-h">
                        <div class="list over-h" v-for="(paa, index) in info.passage" :key="index">
                            <div class="t1 one-text">{{ paa.tebp_title }}</div>
                            <div class="d1 one-text">{{ paa.tebp_desc }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- 内容部分 -->

        <div class="content mt-56 mb-120">
            <div class="content-box df">
                <!-- 左侧 -->
                <div class="left-box over-h">
                    <div class="list one-text" v-for="(item, index) in tabdata" :key="index" :title="item.tebc_name"
                        :class="{ 'active': thumbsindex == index }" @click="onSlideClick(index, item.tebc_id)">{{
                        item.tebc_name}}</div>
                    <!-- <div class="list df aic">趋势动态</div>
                    <div class="list df aic">趋势动态</div>
                    <div class="list df aic">趋势动态</div> -->
                </div>

                <!-- 中间数据列表 -->
                <div class="center-box f1 over-h">
                    <div class="list-box">
                        <div class="list mb-16 df" v-for="(item, index) in centerList" :key="index"
                            @click="handleNavigation(item)">
                            <div class="img-box fn">
                                <el-tooltip placement="top-start" effect="light" :offset="-50" popper-class="tooltip-boxss">
                                    <div slot="content" class="toop-box">
                                        <div class="name">{{ item.tebar_export_name }}
                                            <span class="t1">{{ item.tebar_export_title }}</span>
                                        </div> 
                                        <div class="desc">
                                            {{ item.tebar_export_desc }}
                                        </div>
                                    </div>
                                    <img :src="item.tebar_export_thumb" alt="">
                                </el-tooltip>
                            </div>
                            <div class="f1 ml-18 over-h">
                                <div class="t1 one-text">
                                    <span class="essence" v-if="item.content_info.rec == 900">{{ $t("精1") }}</span>{{
                                    item.tebar_title }}
                                </div>
                                <div class="d1 mt-8 fs-14 lh-22 tow-text">
                                    {{ item.tebar_desc }}
                                </div>

                                <div class="date df jcfe mt-10">
                                    <div class="li fs-14 mr-14">
                                        <span class="iconfont icon-yanjing"></span>
                                        <span class="td1 ml-4">{{ item.content_info.hits }}</span>
                                    </div>
                                    <div class="li fs-14 mr-14">
                                        <span class="iconfont icon-dianzan1"></span>
                                        <span class="td1 ml-4">{{ item.content_info.likes }}</span>
                                    </div>
                                    <div class="li fs-14 mr-14">
                                        <span class="iconfont icon-xiaoxi1"></span>
                                        <span class="td1 ml-4">{{ item.content_info.reply_count }}</span>
                                    </div>

                                    <div class="da1 fs-14">
                                        {{item.content_info.release_time * 1000, "YYYY.MM.DD HH:mm" | formatTime}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-data pt-86" v-if="centerList.length == 0">
                        <img src="@/assets/images/empty_data.png" alt="" />
                        <p>{{ $t("暂无数据") }}</p>
                    </div>
                </div>

                <!-- 中间数据列表 -->
                <div class="right-box">
                    <div class="t1 fs-32 mic-semblod">{{ $t("往期汇总") }}</div>

                    <div class="right-list" v-for="(item, index) in rightList" :key="index"
                        @click="$navigate('/journal/info', item.teb_id)">
                        <div class="list">
                            <div class="tow-text t2 fs-18 mic-semblod lh-26">【{{ item.teb_num }}】{{ item.teb_title }}</div>
                            <div class="d2 lh-22 mt-3">
                                <span class="iconfont icon-shijian-xianxing"></span>
                                <span class="fs-14 ml-4">{{ item.teb_published_time }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="no-data pt-86" v-if="rightList.length == 0">
                        <img src="@/assets/images/empty_data.png" alt="" />
                        <p>{{ $t("暂无数据") }}</p>
                    </div>
                </div>

            </div>

            <div class="pageing-box mt-36 df aic jcc" v-if="centerList.length > 0">
                <el-pagination :current-page="pagination.page" :page-size="pagination.per_page"
                    :total="pagination.total" layout=" prev, pager, next,slot,sizes" @size-change="handleSizeChange"
                    @current-change="handleCurrent">
                    <span class="jump-text">{{ $t('跳转') }}</span>
                    <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages"
                        @change="handleJump" size="small" class="jump-ipt" style="width: 48px; margin-left: 8px;" />
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getEbookInfo, getEbookCategory, getEbookArticleList, getEbookPreviousList,journalStats } from "@api/ebook";
import { getMyInfo } from "@api/home";
export default {
    data() {
        return {

            // 分页
            pagination: {
                page: 1, // 当前页码
                per_page: 10, // 每页显示的数量
                total: 0, // 总数量
            },
            totalPages: 0, //总页数
            jumpIndex: '',
            activeIndex: 0, // 活动的索引
            // 往期汇总
            rightList: [],
            // 中间数据
            centerList: [],
            info: [],
            searchForm: {},
            thumbsindex: 0,
            tabdata: [],
            userinfo: [],
        }
    },
    created(){
        setTimeout(() => {
            this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
        }, 600);
    },
    computed: {
        id() {
            return this.$route.params.id; // 获取路由参数
        },
    },
    mounted() {
        this.getData();
        this.getEbookPreviousData();
        this.getCurrUserData();
    },
    methods: {
        async getData() {
            let res = await getEbookInfo({
                id: this.id,
            });
            if (res.status == 200) {
                this.info = res.data;
                this.getRelationList();
            }
        },
        // 相关文章
        async getRelationList() {
            //获取相关文章分类
            const res = await getEbookCategory({ pid: this.info.tebc_id, teb_id: this.info.teb_id });
            this.tabdata = res.data;
            console.log(this.tabdata)
            if (this.tabdata.length > 0) {
                if (!this.searchForm.tebc_id) {
                    // 默认选择第一个
                    this.thumbsindex = 0;

                    this.searchForm.tebc_id = this.tabdata[0].tebc_id;
                }
                this.searchForm.teb_id = this.info.teb_id
                this.getEbookArticleData();
            }

        },
        //文章列表
        async getEbookArticleData() {
            this.listLoading = true;
            const resList = await getEbookArticleList({
                ...this.searchForm,
                page: this.pagination.page,
                rows: this.pagination.per_page,
            });
            if (resList.status == 200) {
                this.pagination.total = resList.data.ebookarticleList.total;
                this.centerList = resList.data.ebookarticleList.data;
                this.pagination.last_page = resList.data.ebookarticleList.last_page;
                this.totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);
            }
            this.listLoading = false;
        },
        //往期汇总
        async getEbookPreviousData() {
            this.listLoading = true;
            const epList = await getEbookPreviousList({
                id: this.id,
                page: this.pagination.page,
            });
            if (epList.status == 200) {
                console.log(epList)
                this.rightList = epList.data.ebookList.data;
            }
            this.listLoading = false;
        },

        onSlideClick(index, tebc_id) {
            this.thumbsindex = index;
            this.searchForm.tebc_id = tebc_id;
            this.getEbookArticleData();
        },
        download(event, params) {
            event.stopPropagation();
            console.log(this.$refs, "...");
            if (this.userinfo.length == 0) {
                sessionStorage.clear();
                setTimeout(() => {
                    let str = "/cn";

                    let Language = localStorage.getItem('currentLanguage');  //获取本地语言
                    if (Language && Language != 'zh') {
                        str = '/en';
                    } else {
                    }

                    const parsedUrl = new URL(window.location.href);
                    const path = parsedUrl.pathname; // This will give you the path

                    const url = str + '/login?callback=' + path; // 你想要跳转的 URL
                    window.open(url);
                }, 1000);
                return;
            }
            window.location.href =
                "/api/protal/api/ebook/downAnnex?content_id=" +
                params.teb_id +
                "&att_id=" +
                params.teb_annex[0].att_id +
                "&type=110";
        },
        handlePages(index) {
            this.pagination.page = index;

        },
        handleJump() {
            this.pagination.page = this.jumpIndex;
            this.getEbookArticleData();
        },
        // 分页改变
        handleCurrent(val) {
            this.pagination.page = val;
            this.getEbookArticleData();

        },

        handleSizeChange(val) {
            this.pagination.per_page = val;
            this.getEbookArticleData();
        },
        async handleNavigation(item) {
          const res = await journalStats({
            content_type : item.tebar_content_type,
            content_id : item.tebar_content_id,
          });
          if (res.status == 200){
            if (item.tebar_content_type === 10) {
              this.$navigate('/discuss/info', item.tebar_content_id);
            } else {
              this.$navigate('/subject/info', item.tebar_content_id);
            }
          }
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },
    }

}
</script>



<style lang="scss" scoped>

.toop-box{
    max-width: 360px;
    .name{
        color: #191919;
        font-size: 14px;
        line-height: 22px;
        .t1{
            padding: 0 5px;
            line-height: 16px;
            height: 16px;
            border-radius: 4px;
            background: rgba(10, 89, 247, 0.1);
            color: #0A59F7;
            font-size: 10px;
            margin-right: 4px;
        }
    }

    .desc{
        margin-top: 4px;
        color: #595959;
        font-size: 12px;
        line-height: 20px;
        max-height: 220px;
        overflow: hidden;
        overflow-y: scroll;

        // 滚动条样式
        &::-webkit-scrollbar {
            width: 4px; // 滚动条宽度
            height: 0px; // 滚动条高度
        }
        &::-webkit-scrollbar-thumb {
            background-color: #ccc; // 滚动条颜色
            border-radius: 4px; // 滚动条圆角 
        }
    }
}
.content{
    padding: 0 80px;
}
.banner {
    width: 100%;
    max-height: 700px;

    background: url('../../assets/images/journalinfo.png') no-repeat center;
    background-size: cover;
    margin-top: 60px;
    padding: 0 80px 42px;

    .banner-box {
        max-width: 1760px;
        margin: 0 auto;
        padding-top: 56px;

    }

    .text-box {
        border-radius: 12px;
        box-shadow: 0px 16px 36px 0px rgba(0, 0, 0, 0.05);
        backdrop-filter: blur(50px);
        background: linear-gradient(180.00deg, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0) 100%);
        margin-left: 34px;
        padding: 48px 30px 42px 40px;

        .title {
            line-height: 38px;
            color: #1a1a1a;
        }

        .desc {
            color: #1a1a1a;
            margin-top: 24px;
        }

        .download-btn {
            margin-top: 16px;
            min-width: 131px;
            height: 36px;
            border-radius: 84px;
            background: rgb(183, 37, 30);
            padding: 0 16px;
            font-size: 14px;
            margin-bottom: 20px;
            border: none;
            &:hover{
                background: #DD736D;
                
            }
        }

    }

    .list-box {
        .list {
            padding: 24px;
            width: calc(50% - 12px);
            height: 104px;
            border: 1px solid rgb(242, 242, 242);
            border-radius: 16px;
            background: rgb(255, 255, 255);
            margin-top: 16px;

            .t1 {
                font-size: 18px;
                font-weight: 500;
                line-height: 26px;
                color: #1A1A1A;
            }

            .d1 {
                width: 100%;
                font-size: 14px;
                color: rgb(89, 89, 89);
                line-height: 22px;
                margin-top: 8px;
                // white-space: nowrap;      /* 禁止换行 */
                // overflow: hidden;         /* 溢出内容隐藏 */
                // text-overflow: ellipsis;  /* 溢出部分显示省略号 */

            }

            &:nth-child(2n) {
                margin-left: 24px;
            }
        }
    }

    .img-box {
        width: 24.11%;
        max-height: 594px;

        img {
            width: 100%;
            border-radius: 12px;
        }
    }
}

.content-box {
    max-width: 1760px;
    margin: 0 auto;

    .center-box {
        padding-left: 20px;
        padding-right: 40px;

        .list-box {
            .list {
                height: 152px;
                border-radius: 12px;
                box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
                background: rgb(255, 255, 255);
                padding-right: 16px;
                cursor: pointer;

                &:hover {
                    .t1 {
                        color: #B7251E;
                    }
                }

                .date {
                    color: #868D9F;

                    .da1 {
                        position: relative;
                        padding-left: 16px;
                    }

                    .da1::before {
                        content: "";
                        display: inline-block;
                        height: 12px;
                        width: 1px;
                        border-radius: 4px;
                        background: #D8D8D8;
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-6px);
                    }
                }

                .t1 {
                    color: rgb(25, 25, 25);
                    font-size: 18px;
                    font-family: "MicrosoftYaHeiSemibold";
                    line-height: 24px;
                    margin-top: 20px;
                }

                .d1 {
                    color: #595959;
                }

                .essence {
                    background: #d71111
                }

                .hot {
                    background: #ff6e00
                }

                .essence,
                .top {
                    display: inline-block;
                    min-width: 18px;
                    height: 18px;
                    border-radius: 2px;
                    font-size: 14px;
                    color: #fff;
                    line-height: 18px;
                    text-align: center;
                    margin-right: 4px;
                    position: relative;
                    padding: 0 2px;
                    top: -2px;
                }
            }

            .img-box {
                padding: 4px;

                img {
                    width: 126px;
                    height: 100%;
                    border-radius: 12px;
                }
            }
        }
    }

    .right-box {
        width: 24.316%;
        max-height: 1664px;
        overflow: hidden;
        overflow-y: scroll;
        // 设置滚动条不显示
        &::-webkit-scrollbar {
            width: 0;
            display: none;
        }
        // 兼容浏览器
        &::-webkit-scrollbar-track {
            width: 0;
            background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
            width: 0;
            background-color: transparent;
        }
        
        // 兼容360浏览器设置窄版滚动条
        &::-webkit-scrollbar-corner {
            width: 0;
            display: none;
        }
        &::-webkit-scrollbar {
            width: 0;
            display: none;
        }
        

        .t1 {
            line-height: 48px;
        }
    }


    .right-list {
        margin-bottom: 2px;

        .list {
            border-bottom: 2px solid rgb(243, 243, 243);
            padding-bottom: 20px;
            padding-top: 35px;
            cursor: pointer;

            &:hover {
                .t2 {
                    color: #B7251E;
                }
            }
        }
    }

    .left-box {
        min-width: 220px;
        width: 15.7%;

        .list {
            font-size: 20px;
            color: #595959;
            width: 100%;
            height: 64px;
            line-height: 60px;
            border-radius: 8px;
            background: rgb(245, 246, 248);
            padding-left: 34px;
            padding-right: 16px;
            margin-bottom: 16px;
            transition: all 0.16s;
            position: relative;
            cursor: pointer;
            z-index: 10;

            &::after {
                content: "";
                display: inline-block;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
                background-image: url("../../assets/images/tab1-bg.png");
                background-size: 100% 100%;
                opacity: 0;
                transition: all 0.36s;
            }
            &.active{
                &::before{
                    content: "";
                    display: block;
                    width: 2px;
                    height: 24px;
                    border-radius: 20px;
                    background: #ffffff;
                    position: absolute;
                    left: 25px;
                    top: 50%;
                    transform: translateY(-13px);
                }

            }
            &.active,
            &:hover {
                color: #ffffff;

                
                &::after {
                    opacity: 1;
                }
            }
        }
    }

}

::v-deep() {
    .pageing-box {
        .el-input-number--small {
            width: 28px !important;
        }

        .el-input-number.is-without-controls .el-input__inner {
            padding-left: 0;
            padding-right: 0;
        }

        .el-input--small .el-input__inner {
            width: 28px;
            height: 28px;
            line-height: 28px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            border-radius: 8px;
        }

        .el-pagination__sizes {

            margin-left: 10px;
            position: relative;
            top: 2px;

            .el-input--mini .el-input__inner {
                border-radius: 8px;
                color: #000000;
                border: 1px solid rgba(0, 0, 0, 0.2);
            }
        }
    }
}
</style>